import { render } from "./SelectCompany.vue?vue&type=template&id=87fcff30"
import script from "./SelectCompany.vue?vue&type=script&lang=js"
export * from "./SelectCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__